module.exports = __webpack_public_path__ + "static/wpack/extracted/wave-videoebec3bf2617817c6a3a5ffdb251ed4de.svg";